import { submitOnlineBookingNewCustomerThunk } from 'actions/onlineBooking/OnlineBookingActions';
import { PoweredByCuddles } from 'components/Cuddles/PoweredBy/PoweredByCuddles';
import { CustomerForm } from 'components/Customer/Form/CustomerForm';
import ErrorList from 'components/Form/ErrorList/ErrorList';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { RightColumn } from 'components/Layout/TwoColumns/RightColumn/RightColumn';
import { MarketplaceInfo } from 'components/Marketplace/Info/MarketplaceInfo';
import { OnlineBookingResume } from 'components/OnlineBooking/Resume/OnlineBookingResume';
import { Button } from 'components/UI/Button/Button';
import { useMarketplace } from 'hooks/useMarketplace';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOnlineBookingCustomer } from 'reducers/onlineBooking/OnlineBookingSelectors';
import { AlertScreen } from 'types/Alert';
import { Customer } from 'types/Customer';

export const OnlineBookingNewClientStep: React.FC = () => {
    const dispatch = useDispatch();
    const marketplace = useMarketplace();
    const { customer } = useSelector(getOnlineBookingCustomer);

    const formRef = React.useRef<HTMLFormElement>(null);

    const [isValid, setIsValid] = React.useState(false);

    const triggerSubmit = () => {
        if (formRef.current) {
            formRef.current.submit();
        }
    };

    const submitHandler = (customer: Customer) => {
        dispatch(submitOnlineBookingNewCustomerThunk(customer));
    };

    return (
        <>
            <LeftColumn contentClassName="flex flex-col flex-1">
                <h1 className="h1 underlined w-full">Personal info</h1>

                <ErrorList screen={AlertScreen.OnlineBookingNewClientForm} className="mt-4 mb-2" />

                <CustomerForm
                    ref={formRef}
                    defaultValues={customer}
                    onChange={setIsValid}
                    onSubmit={submitHandler}
                />

                <div className="pt-6 mt-auto hide-on-mobile-and-tablet">
                    <PoweredByCuddles />
                </div>
            </LeftColumn>

            <RightColumn
                poweredByCuddles
                footer={
                    <Button fullWidth disabled={!isValid} onClick={triggerSubmit}>
                        Continue
                    </Button>
                }
            >
                <div className="flex flex-col gap-5 hide-on-mobile-and-tablet">
                    <MarketplaceInfo inverted marketplace={marketplace} />

                    <OnlineBookingResume />
                </div>
            </RightColumn>
        </>
    );
};
